export default __webpack_public_path__ + "static/media/torso-low-left-side.dcd65127.png";